import { useState } from "react";
import { toast } from "sonner";
import { useApi } from "@/lib/api";

// "This is not me": lanes and topics are read from the creator's posts and
// cannot be edited by the creator. This link lets them tell us the read is
// wrong. It records a flag that an admin reviews and fixes.
const AREAS = [
    { key: "lanes", label: "Lanes" },
    { key: "topics", label: "Topics" },
    { key: "summary", label: "Summary" },
    { key: "other", label: "Something else" },
];

export default function NotMe({ shown = {}, dark = false, testid = "not-me" }) {
    const { request } = useApi();
    const [open, setOpen] = useState(false);
    const [area, setArea] = useState("lanes");
    const [note, setNote] = useState("");
    const [sending, setSending] = useState(false);
    const [sent, setSent] = useState(false);

    const muted = dark ? "text-on-ink-muted" : "text-black/60";
    const text = dark ? "text-paper" : "text-ink";

    if (sent) {
        return (
            <p data-testid={`${testid}-sent`} className={`text-xs ${muted}`}>
                Thanks. We'll check this and fix it.
            </p>
        );
    }

    if (!open) {
        return (
            <button
                type="button"
                data-testid={testid}
                onClick={() => setOpen(true)}
                className={`text-xs underline underline-offset-4 ${muted}`}
            >
                This is not me
            </button>
        );
    }

    const send = async () => {
        setSending(true);
        try {
            await request("/not-me", {
                method: "POST",
                body: { area, note: note.trim() || null, ...shown },
            });
            setSent(true);
        } catch (err) {
            toast.error(err?.message || "Could not send. Try again.");
        } finally {
            setSending(false);
        }
    };

    return (
        <div
            data-testid={`${testid}-form`}
            className={`rounded-xl p-3 space-y-3 ${dark ? "" : "bg-white border border-black/10"}`}
            style={dark ? { background: "var(--color-ink-raised)" } : undefined}
        >
            <div className={`text-sm font-semibold ${text}`}>What's off?</div>
            <div className="flex flex-wrap gap-2">
                {AREAS.map((a) => (
                    <button
                        key={a.key}
                        type="button"
                        data-testid={`${testid}-area-${a.key}`}
                        data-selected={area === a.key}
                        onClick={() => setArea(a.key)}
                        className="samoony-chip"
                    >
                        {a.label}
                    </button>
                ))}
            </div>
            <textarea
                data-testid={`${testid}-note`}
                className="samoony-input w-full text-ink"
                rows={3}
                maxLength={1000}
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder="Tell us what you post about (optional)"
            />
            <div className="flex gap-2">
                <button
                    type="button"
                    onClick={() => setOpen(false)}
                    className={`text-xs underline underline-offset-4 ${muted}`}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    data-testid={`${testid}-send`}
                    onClick={send}
                    disabled={sending}
                    className="samoony-pill samoony-pill-primary ml-auto disabled:opacity-30"
                >
                    {sending ? "Sending..." : "Send"}
                </button>
            </div>
        </div>
    );
}
